var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 45,
    fill: "url(#pattern0_3986_28580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3986_28580",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3986_28580",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3986_28580",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATlSURBVHic7ZtdbBRVGIafb9tqiwpFbEVjma6loiaa+IP2QkxqrDFK/SEhDVz4FxMN8UJIo8ZootxpUjVGLxSqEY0agRAoCS0YAwmxMYLRoFAEOrO7agy04Uflp+3282Jo6Ha63d3ZMzOk7ZP05syc97zn7eyc/WbOCmGidjnQAtIELASqgFIgCfobsAkqOpC5/4VlSUIZRVUg+QLoq8DcHGcfA30datcikg7aWvABaGI26DpgcYE9O2HGUqT63yBsjRBsAGpXgnwH3OZTYS9IE2IdN2lrNLGghNFUBbAF/5MHuAN0G3r0ckOuPAQTgO4pg/R6kEUG1O6G05vQQ5ca0PJgPgBVgaqPgYcNqt4PZV+iWmJQEwjkCki0gT5lXpclkPzAtKjZANR+A1hpVDNzgOdRZ7VJRXOrgDorgA+N6U1MK1LbZkLITABqLwP5giBXlTEjAs8itZ8UK1R8AJpoAu0AArlLT0AaaEFqNxYjUlwAajeAfAtcVpSOf86CPojEd/kV8B+Apm6B9E7gSt8aZjgFch9i7fXT2V8AmrgedDdwja/+5ukDXYTEewrtWPhNSw9Xg27j4pk8wFUgO9Beq9COhQWgR2ZBaSdwQ6EDhcB1bgiHqwvplH8AmqqAWAfFFTcBI/VQshXtuSLfHvkF4BY3GwwVNwEjC6F88/mnTznJHYBb3KwBHirWWog0QuxrVEtznZjHFZB8B/RJE67CRR8Fp939B2Zn4gDUfhP0RaO+QkWeAOe9Cc/IeiTc4iZg5GXEenvcI+Oer85y4HPCK26CRkGeQ6w1Yw94A3CLm63AJWE4C5E0yHLE+mZ0Y2YA0Rc3QTMA+ggS7xppuBCAW9zsAmZH4SxETgNNSO33MBKAJutgeDe539pMFvpB7kWs/YIemgllP3Jxfr8PEhv09hiUrmLqTR4gDtIqqHMAuDFqNxFxUFDnHJNvycuXwRhTd/IAZZPlm55vcpaLAaCAAyRAEqAzcHeKWEA8bDMhBqD7QD6D9HqkLjn+KUfqIbYYZAUwPwxXgjoa8Bh/A6+B9Skiw3n10D1lUPU06Grg6iDNBR1ANww9hsw/6qu3Jq+F4Y1Ag1lbFwjyJrgBBht9Tx5A5v0F2gi6xaCvzCECugJ+gpJ7kJozRtQ0VQHDO0HvMqI3iiCugD6INWedvNrLUOdX1B5AHXX/7AHU2YfaLeP2kZozII8DJ02bDeAK0JVI3PscTu1K4AeQXHXHARhsQOpPeTUSL4G+Zcani+kAEjC4AKk/l9HqbpdzgFl52joBA5YnBLXLQQ4C84y4xfxHYJ1n8i7d5D15AK2Esm5Ps8TPgn7l2904GA5ANnuatHcpiJ9q82Y0tcTbXFLUhoixmPwIHAdrDiKZeur8AtzqT1J/RuKZ7yJVBRIngJn+NDMxeQWkPJN3WVCE5k2eFneMVBGaGZgM4M8s7UWU25Klr/zhXzMTkwFk29VdzD6kLH3Vu0T6ZMo/D5gOIGoDUTMdQNQGomY6gKgNRE0M+CdqExFyMgaM/4R2SqDJGLA9ahvRIV0xkLW4e++nGkOg7THE2g86SXaDFcT7SLzn/CrQ3wrSNfH5k4pO6HsFRpZBuXMQjjUD7wJDERoLmkGgDaxmd86j3w26DavQ3o9AngF5AKgB5kRi1Rz9uD/P3wHD7Ujd76MP/g8IZWm1COr4kgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fe0f0f907973b283ecaf5deefb3ff522.svg";
export { ForwardRef as ReactComponent };